import {
    OPEN_POLICY_SEARCH_MODAL, SAVE_POLICY_RESULT
} from '../actions/policies';


const initialState = {openSearchModal:false}

export default (state = initialState, action) => {
    switch (action.type) {
        case OPEN_POLICY_SEARCH_MODAL:
            return {
                ...state,
                openSearchModal:action.payload ,
            };
        case SAVE_POLICY_RESULT:
            return {
                ...state,
                savePolicyResult:action.payload ,
            };
        case "@@localize/SET_ACTIVE_LANGUAGE":
            
            localStorage.setItem('currentLanguage',action.payload.languageCode);
        default:
            return state;

    }
};



// WEBPACK FOOTER //
// ./src/reducers/policies.js